import React, { useCallback, useState } from 'react';
import axios from 'axios';
import AsyncSelect from 'react-select/async';
import debounce from 'lodash.debounce';

const InfiniteScrollList = ({ setProductData }) => {
  const Node_BE_URL = 'https://onecmapp-apis.onecannabismarketinc.com';
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Load options from API
  const fetchProducts = async (inputValue) => {
    if (!inputValue || inputValue.trim() === '') return [];

    try {
      const response = await axios.post(`${Node_BE_URL}/api/getProductsbyName`, {
        search: inputValue,
      });

      const products = response?.data?.data || [];

      return products.map((product) => ({
        value: product.id,
        label: product.name,
      }));
    } catch (error) {
      console.error('Error loading products:', error);
      return [];
    }
  };

  // Debounced function
  const debouncedLoadOptions = useCallback(
    debounce((inputValue, callback) => {
      fetchProducts(inputValue).then(callback);
    }, 500),
    []
  );

  // Handle product selection
  const handleChange = (selectedOption) => {
    setSelectedProduct(selectedOption);
    setProductData((prev) => ({
      ...prev,
      product: selectedOption?.value,
    }));
  };

  return (
    <div className="plain-dropdown my-3">
      <label htmlFor="">Products</label>
      <br />

      <AsyncSelect
        cacheOptions
        loadOptions={debouncedLoadOptions}
        defaultOptions={false}
        isSearchable
        placeholder="Search and select a product"
        onChange={handleChange}
        noOptionsMessage={() => 'No products found'}
      />

      {selectedProduct && (
        <div className="mt-2">
          <strong>Selected:</strong> {selectedProduct.label}
        </div>
      )}
    </div>
  );
};

export default InfiniteScrollList;
